import {IGameRealityCheckInterval, IRegulation} from "./regulation.service.interface";
import {ILegacyRegulation} from "./legacy-regulation.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {REGULATION_NAMES} from "../../../sdk/src/services/regulation/regulation_const";
import {
    IExternalLinksHandlersFactory
} from "../external-links/handlers-factory/external-links-handlers-factory.interface";
import {ExternalLinksHandlersFactory} from "../external-links/handlers-factory/external-links-handlers-factory";
import {IRegulationComponents} from "./regulation-components.interface";
import {RegulationComponentsCommon} from "./regulation-components-common";
import {IRegulationMenuItemFactory} from "../menu-items-common/regulations-specific/regulation-menu-item-factory.interface";
import {RegulationMenuItemFactoryBase} from "../menu-items-common/regulations-specific/regulation-menu-item-factory-base";
import {
    IRegulationLinkNavigationHook
} from "../links-navigation/regulation-hooks/regulation-link-navigation-hook.interface";
import {RegulationNavigationHookBase} from "../links-navigation/regulation-hooks/regulation-navigation-hook-base";
import { GameChildishIconMode } from "../../../common/enums/game-childish-icon-mode.enum";
import {GameInfo} from "../games/game-info";
import {TimeSpan} from "@sparkware/app-utils";
import {IRealityCheckHandler} from "../session-timer/reality-check/handlers/reality-check-handler.interface";
import {VoidRealityCheckHandler} from "../session-timer/reality-check/handlers/void-reality-check-handler";
import {RegulationStandardTimeFormatter} from "./regulation-standard-time-formatter";
import {IRegulationTimeFormatter} from "./regulation-time-formatter.interface";

export class LegacyRegulationWrapper implements IRegulation {
    constructor(protected readonly legacyRegulation: ILegacyRegulation,
        public readonly regulationType: number,
        protected services: IServiceFactoryExtended) {
    }
    get name(): string {
        return REGULATION_NAMES[this.regulationType];
    }

    get responsibleGamingAge(): number {
        return this.services.sdk.getSkin().getMinimumAge();
    }

    get isSessionTimerEnabled(): boolean {
        return false;
    }

    getRealityCheckInterval(): TimeSpan {
        return TimeSpan.fromMilliseconds(0);
    }

    getRealityCheckIntervalExpectedByTheGame(): IGameRealityCheckInterval {
        return {
            timeSpan: TimeSpan.fromMilliseconds(0),
            expectedValueByTheGame: 0
        }
    }

    createRealityCheckHandler(): IRealityCheckHandler {
        return new VoidRealityCheckHandler();
    }


    async disableRealityCheck(): Promise<void> {
        await this.services.user.setNewRealityCheckInterval(TimeSpan.fromMilliseconds(0));
    }

    showNightLimitMessage(nightLimitExpirationDate: Date) {
        this.legacyRegulation.showNightLimitMessage(nightLimitExpirationDate);
    }

    get postLoginActionsArePassed(): boolean {
        return this.legacyRegulation.postLoginActionsArePassed();
    }

    logoutUser(): Promise<void> {
        return this.services.user.logout();
    }

    get externalLinks(): IExternalLinksHandlersFactory {
        return new ExternalLinksHandlersFactory(this.services);
    }

    get components(): IRegulationComponents {
        return new RegulationComponentsCommon(this.services);
    }

    get menuItems(): IRegulationMenuItemFactory {
        return new RegulationMenuItemFactoryBase(this.services);
    }

    get linksNavigationHook(): IRegulationLinkNavigationHook {
        return new RegulationNavigationHookBase();
    }

    get gameIconAnimationsAllowed(): boolean {
        return this.legacyRegulation.gameIconAnimationsAllowed();
    }

    getChildishIconMode(): GameChildishIconMode {
        return this.legacyRegulation.getChildishIconMode();
    }

    get isGamblingSessionEnabled(): boolean {
        return false;
    }

    openInactivitySettings(): void {
    }

    get shouldShowExitGamePopup(): boolean {
        return true;
    }

    computeGameMaxLimitInCents(gameInfo: GameInfo): number {
        return this.services.wallet.computeGameMaxLimit(gameInfo);
    }

    computeGameMinLimitInCents(gameInfo: GameInfo): number {
        return 0;
    }

    get timeFormatter(): IRegulationTimeFormatter {
        return new RegulationStandardTimeFormatter(this.services);
    }
}